var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-col',{attrs:{"align":"center"}},[_c('v-card',[_c('v-img',{attrs:{"src":require('../assets/catalog-yaowarat.jpg')}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }